import ArticleResourcePagingResultModel from '../../generated/types/model/resource/ArticleResourcePagingResultModel';

export default class ArticleResourcePagingResultViewModel extends ArticleResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
